import React from 'react';
import { Badge, Tooltip, Transition } from '@mantine/core';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import AppIcon from '@/components/AppIcon.tsx';
import { ParentStep } from '@/types/automationSteps.ts';
import StepCardPill from '@/components/StepCard/StepCardPill.tsx';
import { useActiveStep } from '@/layouts/AutomationPageWrapper/hooks/useActiveStep.ts';

type Props = {
  fieldErrorsCount: number;
  parentSteps: ParentStep[];
  stepId: string;
};

export default function WarningPills({ fieldErrorsCount, parentSteps, stepId }: Props) {
  const { setActiveStep } = useActiveStep();

  return (
    <Transition
      mounted={fieldErrorsCount > 0}
      transition="slide-up"
      duration={400}
      timingFunction="ease"
    >
      {(styles) => (
        <div style={styles}>
          <StepCardPill parentStepsCount={parentSteps.length}>
            <Tooltip label={`${fieldErrorsCount} field error${fieldErrorsCount > 1 ? 's' : ''}`}>
              <Badge
                bg={'#ECECED'}
                c={'#0F172A'}
                fw={500}
                size={'md'}
                tt="none"
                style={{ cursor: 'pointer' }}
                onClick={() => setActiveStep(stepId)}
                styles={{ label: { fontSize: '12px', display: 'flex' } }}
              >
                <AppIcon Icon={HiOutlineExclamationTriangle} size={14} />
              </Badge>
            </Tooltip>
          </StepCardPill>
        </div>
      )}
    </Transition>
  );
}
